import { useState } from "react";
import { addVersionsForm } from "../../lib/actions"; 
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AddApiVersionUi() {

    const nav = useNavigate();
    const [loading, setLoading] = useState(false);
    
    // 1. Add State for toggles
    const [force, setForce] = useState(false);
    const [isActive, setIsActive] = useState(true);

    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();

        // 2. Create FormData from text fields
        const formData = new FormData(e.target);

        // 3. Manually append the toggle values as 1 or 0
        formData.append("force", force ? "1" : "0");
        formData.append("is_active", isActive ? "1" : "0");

        const result = await addVersionsForm(formData, navigate);
        setLoading(false);
    };

    const navigate = (route) => {
        nav(route);
    };

    return (
        <form onSubmit={handleSubmit} className="">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                
                {/* ... Version, Type, Release Notes, URL inputs remain exactly the same ... */}
                <div className="mb-4">
                    <label className="block text-white mb-2">{t("form.version") || "Version (e.g. 1.0.2)"}</label>
                    <input type="text" name="version" className="w-full px-4 py-2 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none" required placeholder="1.0.0" />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{t("form.platform") || "Platform"}</label>
                    <div className="flex gap-4">
                        <select name="type" className="w-full px-4 py-1 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none">
                            <option value="android">Android</option>
                            <option value="ios">iOS</option>
                        </select>
                    </div>
                </div>
                <div className="mb-4 col-span-1 md:col-span-2">
                    <label className="block text-white mb-2">{t("form.release_note_en") || "Release Note (EN)"}</label>
                    <textarea name="release_note[en]" rows="3" className="w-full px-4 py-2 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none" placeholder="What's new in this version..."></textarea>
                </div>
                <div className="mb-4 col-span-1 md:col-span-2">
                    <label className="block text-white mb-2">{t("form.release_note_ar") || "Release Note (AR)"}</label>
                    <textarea name="release_note[ar]" rows="3" className="w-full px-4 py-2 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none text-right" placeholder="...ما الجديد في هذا الإصدار"></textarea>
                </div>
                <div className="mb-4 col-span-1 md:col-span-2">
                    <label className="block text-white mb-2">{t("form.store_url") || "Store URL"}</label>
                    <input type="url" name="store_url" className="w-full px-4 py-2 bg-thirdly border border-gray-500/50 text-white rounded-lg focus:border-secondary outline-none" required placeholder="https://play.google.com/..." />
                </div>

                {/* Toggles Section - UPDATED */}
                <div className="mb-4 col-span-1 md:col-span-2 flex flex-col sm:flex-row gap-8 mt-2">
                    
                    {/* Force Update Toggle */}
                    <div className="flex items-center justify-between bg-thirdly p-4 rounded-xl border border-white/5 w-full sm:w-1/2">
                        <span className="text-white font-medium">{t("form.force_update") || "Force Update"}</span>
                        <label className="relative inline-flex items-center cursor-pointer">
                            {/* Removed hidden input and name attribute */}
                            <input 
                                type="checkbox" 
                                checked={force}
                                onChange={(e) => setForce(e.target.checked)}
                                className="sr-only peer" 
                            />
                            <div className="w-11 h-6 bg-gray-600 rounded-full peer peer-focus:ring-4 peer-focus:ring-secondary/30 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-secondary"></div>
                        </label>
                    </div>

                    {/* Is Active Toggle */}
                    <div className="flex items-center justify-between bg-thirdly p-4 rounded-xl border border-white/5 w-full sm:w-1/2">
                        <span className="text-white font-medium">{t("form.is_active") || "Is Active"}</span>
                        <label className="relative inline-flex items-center cursor-pointer">
                            {/* Removed hidden input and name attribute */}
                            <input 
                                type="checkbox" 
                                checked={isActive}
                                onChange={(e) => setIsActive(e.target.checked)}
                                className="sr-only peer" 
                            />
                            <div className="w-11 h-6 bg-gray-600 rounded-full peer peer-focus:ring-4 peer-focus:ring-secondary/30 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-secondary"></div>
                        </label>
                    </div>

                </div>
            </div>

            <div className="flex justify-center w-full mt-8">
                <button type="submit" disabled={loading} className={`w-full sm:w-2/5 md:w-[20%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary" }`}>
                    {loading ? (
                        <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                        </svg>
                    ) : t("button.save")}
                </button>
            </div>
        </form>
    );
};